import elemento_base_model from './elemento_base_model';

export default {
  Codigo: null,
  Descripcion: null,
  Activo: true,
  CodigoElementoBase: null,
  ElementoBase: { ...elemento_base_model },
  ProcesoPorDefecto: [],
};
